// This is the default environment file loaded for Canary configuration

/**
 * 1p app related constants
 */
export const EHR_APP_DOMAIN = "https://ehrconnectorsvc.teams.microsoft.com";
export const EHR_APP_CLIENT_ID = "c44767c6-a632-4919-85f8-2845379cd94c";

/**
 * Telemetry related constants
 */
export const EHR_APP_NAME = "EHRConnector";
export const EHR_APP_ENV = "canary";

/**
 * API related constants
 */

// Default endpoint to use when no valid endpoint was passed
// ONLY populate `host` part of the URL here.
export const EHR_API_ENDPOINT = "ehrconnectorsvc-canary.teams.microsoft.com";

/**
 * List of hosts that are allowed to be valid EHR MT endpoints
 * ONLY populate `host` part of the URL here.
 */
export const EHR_API_VALID_ENDPOINTS = [
  EHR_API_ENDPOINT,
  "ehrconnectorsvc-canary.teams.microsoft.com:8312",
];

export const EHR_API_ENDPOINT_PATH = "/api/graphql/v1";
export const EHR_API_EPIC_PATH = "/api/epic";
export const EHR_API_QUEUE_PATH = "/api/v1/odata/listview";
